import React, { useEffect, useState, useRef} from "react";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { AuthServices } from "../../features/auth/services/AuthServices";
import { OverlayService } from "../../features/home/service/OverlayService";
import logo from "../../assets/icons/NewLogo.png";

const GoogleAuth = ({ disabled }) => {
  const navigate = useNavigate();
  const lastCountedIdRef = useRef(null);
  const [showGoogleModal, setShowGoogleModal] = useState(false);
  return (
    // <div className="social-login-container">
    <div
      className={`social-login-container ${disabled ? "disabled-container" : ""}`}
      style={{ pointerEvents: disabled ? "none" : "auto", opacity: disabled ? 0.5 : 1 }}
    >
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <GoogleLogin
        theme="filled_blue"
        useOneTap={true}
        auto_select={true}
        width="100%"
        onClick={() => {
            // Called just before popup opens
            setShowGoogleModal(true);
            console.log("google signin start");
          }}
          onSuccess={async (response) => {

            setShowGoogleModal(true);
            //console.log("google signin start");


            try {
              const serverResponse = await AuthServices.googleLogin(response);
              if (serverResponse.status === 200) {
                      localStorage.setItem("lastActivityAt", String(Date.now()));
                      localStorage.setItem("expertReplyCount", "0");
                      localStorage.setItem("userlogin", 'Google');
                      lastCountedIdRef.current = null;
                      localStorage.removeItem("lastCountedMsgId");

                      let conversationId = localStorage.getItem("conversation_id");
                  
                      if (!conversationId) {
                        
                          const response = await OverlayService.createNewSession();
                          conversationId = response?.data?.conversation_id;
                
                          if (conversationId) {
                            localStorage.setItem("conversation_id", conversationId);
                            console.log("🔹 New session created:", conversationId);
                          }
                        } else {
                        console.log("✅ Existing session found:", conversationId);
                      }
                navigate("/home");
              }
            } catch (error) {
              console.log(
                "There was an error retreiving your credentials",
                error
              );
            }
          }}
          onError={() => {
            console.log("Login Failed");
          }}
          onStart={() => {
            console.log("Login Started");
          }}
          
          disabled={disabled}
        />
      </GoogleOAuthProvider>

      {showGoogleModal && (
        <div className="modal-overlay-google">
        <div className="modal-box-google">
      <img
        src={logo}
        alt="Prashasync Logo"
        className="modal-logo-google"
      />
      <h3>Please wait… </h3>
      <p>Authenticating your account securely.</p>
    </div>
  </div>
      )}

    </div>
  );
};

export default GoogleAuth;
